import { formatDayOfWeekMonthDay } from '@fruitful/fruitils';
import { useMemo } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
    BodySmallRegular,
    H6Regular,
    SafeAreaView,
    useThemeColors,
    XStack,
    YStack,
} from 'smoothie';

import { type HeaderHomeContext, TabHeaderButtons } from './TabHeaderButtons';

export const BASE_TAB_HEADER_HEIGHT = 96; // 48 for content, 48 for padding.

interface TabHeaderProps {
    headerTitle: string;
    headerHomeContext?: HeaderHomeContext;
    showMessaging?: boolean;
}

const TabHeader = ({
    headerTitle,
    headerHomeContext,
    showMessaging,
}: TabHeaderProps) => {
    const { top } = useSafeAreaInsets();
    const { getColor } = useThemeColors();

    const HeadingComponent = useMemo(() => {
        if (
            headerHomeContext === 'headerNavbar' ||
            headerHomeContext === 'topNavbar'
        ) {
            return (
                <YStack
                    gap={4}
                    alignItems="flex-start"
                    justifyContent="center"
                    flexShrink={1}
                >
                    <H6Regular>{headerTitle}</H6Regular>
                    <BodySmallRegular color="$gray1000">
                        Today is {formatDayOfWeekMonthDay(new Date())}
                    </BodySmallRegular>
                </YStack>
            );
        } else {
            // non-Home pages
            return (
                <YStack justifyContent="center">
                    <H6Regular>{headerTitle}</H6Regular>
                </YStack>
            );
        }
    }, [headerHomeContext]);

    return (
        <SafeAreaView
            noBottomPadding={true}
            edges={['left', 'right']}
            style={{
                width: '100%',
                zIndex: 10,
                backgroundColor:
                    headerHomeContext !== undefined
                        ? 'transparent'
                        : getColor('$white'),
                paddingTop: top,
            }}
        >
            <XStack
                height={BASE_TAB_HEADER_HEIGHT}
                width="100%"
                justifyContent="space-between"
                alignItems="center"
                paddingHorizontal={24}
                $sm={{
                    paddingVertical: 24,
                }}
            >
                {HeadingComponent}
                <TabHeaderButtons showMessaging={showMessaging} />
            </XStack>
        </SafeAreaView>
    );
};

export default TabHeader;
